const languageSwitcherInit = (switcher: HTMLElement) => {
  const toggler: HTMLElement = switcher.querySelector('.language-switcher__current');
  const options: HTMLElement = switcher.querySelector('.language-switcher__options');

  toggler?.addEventListener('click', () => {
    toggler.classList.toggle('active');
    options.classList.toggle('active');
  });
};

export default languageSwitcherInit;
